<template>
    <div v-if="loader">
        <Loading />
    </div>
    <div v-else>
        <SedeCampusUniversitario :municipio_id="municipio" sede="Campus Universitario" v-if="sede_id == 10" />
        <Principal :municipio_id="municipio" v-else />
    </div>
</template>
<script>
    import Loading from '../Loader/Loading.vue';
    import SedeCampusUniversitario from '../Mapas/SedeCampusUniversitario.vue';
    import Unidades from '@/views/Unidades.vue';
    import Principal from '../Mapas/Principal.vue';

    export default {
        components: {
            Loading, SedeCampusUniversitario, Unidades, Principal
        },
        data() {
            return {
                loader: true,
                municipio: 0,
                sede_id: 0
            }
        },
        mounted() {
            this.getBloques();
            this.municipio = this.$route.params.municipio;
        },
        methods: {
            getBloques(){
                this.sede_id = this.$route.params.id;
                this.loader = false;
            },
            
        },
    }
</script>